// Bridge between the react-router <Router getUserConfirmation> hook (outside the
// React tree) and the <UnsavedChangesGuard> component, which renders the modal.
let handler = null;
let bypassOnce = false;

export const setConfirmHandler = (fn) => {
  handler = fn;
};

// Called by react-router when a <Prompt> blocks a transition. Delegates to the
// guard's handler if registered; otherwise falls back to the native confirm.
export const getUserConfirmation = (message, callback) => {
  // Already confirmed via confirmNavigation -> let the follow-up push through.
  if (bypassOnce) {
    bypassOnce = false; return callback(true);
  }
  return handler ? handler(message, callback) : callback(window.confirm(message)); // ponytail: native fallback
};

// Explicit confirm for state-driven navigation that <Prompt> can't intercept
// (e.g. the data-dictionary list<->detail toggle). Runs onConfirm only if the
// user chooses "Continue Without Saving". Sets a one-shot bypass so the real
// history.push inside onConfirm doesn't re-open the modal via <Prompt>.
export const confirmNavigation = (onConfirm) => {
  if (!handler) return onConfirm();
  return handler('unsaved-changes', (allow) => {
    if (!allow) return;
    bypassOnce = true;
    try {
      onConfirm();
    } finally {
      bypassOnce = false;
    }
  });
};
